import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store'
import router from './router'
import moment from 'vue-moment'
import vSelect from 'vue-select'

import VeeValidate from 'vee-validate'

import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import VueOffline from 'vue-offline'

// Import indexed db
import VueIdb from 'vue-idb'
// Import Vue signature
import vueSignature from 'vue-signature'

// Theme adding
import Argon from './plugins/argon-kit'
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import ImageUploader from 'vue-image-upload-resize'

Vue.use(VueFormGenerator)
Vue.use(BootstrapVue)
Vue.use(Argon)
Vue.use(VeeValidate, {
  errorBagName: 'vErrors',
  fieldsBagName: 'vFields'
})
Vue.use(moment)

Vue.use(VueRouter)
Vue.use(VueIdb)
Vue.use(vueSignature)
Vue.use(VueOffline)
Vue.component('v-select', vSelect)
Vue.use(ImageUploader)

const idb = new VueIdb({
  version: 1,
  database: 'logistic',
  schemas: [
    { images: 'id, canvas' },
    { signatures: 'id, canvas' }
  ]
})

Vue.config.productionTip = false

new Vue({
  store,
  router,
  idb,
  render: h => h(App)
}).$mount('#app')
